import BookmarkIcon from "@mui/icons-material/Bookmark";

export const bookmark = (props) => {
  return <BookmarkIcon {...props} />;
};
